import { useQuery } from '@tanstack/react-query';
import useGlynt from './useGlynt';

export default function useDataPool() {
  const glynt = useGlynt();

  return useQuery({
    queryKey: ['dataPool'],
    queryFn: async () => await (await glynt).dataPool.retrieve(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60
  });
}
